import React from "react";
import { DatePicker, Col, Form, Radio, Row, Select } from "antd";
import locale from "antd/lib/date-picker/locale/ja_JP";
import * as moment from "moment-timezone";
import { observer } from "mobx-react";

import { FInput, FSelect } from "../../common/form";
import PetsTemplateRender from "../PetsTemplateRender";
import SiblingTemplateRender from "../SiblingTemplateRender";
import Book from "../../models/Book";
import { hankaku2Zenkaku } from "../../utils/";

moment.tz.setDefault("Asia/Tokyo");

const Option = Select.Option;

const Input = ({ label, span, ...props }) => (
  <Col span={span}>
    <FInput label={label} {...props} />
  </Col>
);

let receiverForParents = false; // productsType が 両親向け(s)か

let isOverOneYear = false; // シカケテガミに刻印する記念日を1年後を選択した時、吹き出しで警告を表示させる

// 文字数制限を超えているか
let isCNameTooLong = false;
const CNameLimit = 10;
let isDadNameTooLong = false;
const DadNameLimit = 6;
let isLifeChangingWordsFromDadTooLong = false;
const LifeChangingWordsFromDadLimit = 20;
let isMomNameTooLong = false;
const MomNameLimit = 6;
let isLifeChangingWordsFromMomTooLong = false;
const LifeChangingWordsFromMomLimit = 20;
let isChildNameTooLong = false;
const ChildNameLimit = 6;

const RadioGroup = Radio.Group;
const radioStyle = {
  display: "block",
  height: "30px",
  lineHeight: "30px"
};

const receiverList = [
  { value: "", text: "" },
  { value: "dad", text: "父" },
  { value: "mom", text: "母" },
];

class Informations extends React.Component {
  constructor(props) {
    super();
    this.state = {
      artistName: props.book.artistName,
      book: Book.create({})
    };
    this.isChangeReceiver = false;
    this.isChangeChildren = false;
    this.isChangeSibling = false;
    this.isChangePets = false;
    this.productType = props.book.productType;
  }

  onReceiver = v => {
    this.isChangeReceiver = true;
    return this.state.book.childToParent.changeReceiver(v);
  };
  onCNameChange = e => {
    let text = e.target.value;
    text = text.replace(/\u3000/g, " ");
    isCNameTooLong = text.length > CNameLimit;
    this.state.book.childToParent.changeCreatorName(text);
  };
  onDadNameChange = e => {
    let text = e.target.value;
    isDadNameTooLong = text.length > DadNameLimit;
    this.state.book.childToParent.changeDadName(text);
  };
  onHasLifeChangingWordsFromDadRadioChange = e => {
    const value = e.target.value;
    this.state.book.childToParent.changeHasLifeChangingWordsFromDad(value);
  }
  onLifeChangingWordsFromDadChange = e => {
    let text = e.target.value;
    isLifeChangingWordsFromDadTooLong = text.length > LifeChangingWordsFromDadLimit;
    this.state.book.childToParent.changeLifeChangingWordsFromDad(text);
  };
  onMomNameChange = e => {
    let text = e.target.value;
    isMomNameTooLong = text.length > MomNameLimit;
    this.state.book.childToParent.changeMomName(text);
  };
  onHasLifeChangingWordsFromMomRadioChange = e => {
    const value = e.target.value;
    this.state.book.childToParent.changeHasLifeChangingWordsFromMom(value);
  }
  onLifeChangingWordsFromMomChange = e => {
    let text = e.target.value;
    isLifeChangingWordsFromMomTooLong = text.length > LifeChangingWordsFromMomLimit;
    this.state.book.childToParent.changeLifeChangingWordsFromMom(text);
  };
  onDateChange = date => {
    const today = moment();
    const nextYear = today.add(1, 'year');
    isOverOneYear = date.isAfter(nextYear.subtract(1, 'days'));
    this.state.book.childToParent.changeCustomDate(date.toDate());
  };
  onChildNameChange = e => {
    let text = e.target.value;
    isChildNameTooLong = text.length > ChildNameLimit;
    this.state.book.childToParent.changeChildName(text);
  };
  onChildrenChange = v => {
    this.isChangeChildren = true;
    isChildNameTooLong = false;
    this.state.book.childToParent.changeChildName(''); // こどもの名前をリセット
    this.state.book.childToParent.changeChildren(v);
  };
  onSiblingChange = v => {
    this.isChangeSibling = true;
    this.state.book.childToParent.changeSibling(v)
  };
  onPetsChange = v => {
    this.isChangePets = true;
    this.state.book.childToParent.changePets(v)
  };

  updateABook(book, bookFrom) {
    const { childToParent } = bookFrom;

    // 全角変換
    // childToParent.changeCreatorName(hankaku2Zenkaku(childToParent.creatorName));
    // childToParent.changeDadName(hankaku2Zenkaku(childToParent.dadName));
    // childToParent.changeMomName(hankaku2Zenkaku(childToParent.momName));
    // childToParent.changeChildName(hankaku2Zenkaku(childToParent.childName));

    book.childToParent.changeCreatorName(childToParent.creatorName);
    book.childToParent.changeReceiver(childToParent.receiver);
    book.childToParent.changeDadName(childToParent.dadName);
    book.childToParent.changeHasLifeChangingWordsFromDad(childToParent.hasLifeChangingWordsFromDad);
    book.childToParent.changeLifeChangingWordsFromDad(childToParent.lifeChangingWordsFromDad);
    book.childToParent.changeMomName(childToParent.momName);
    book.childToParent.changeHasLifeChangingWordsFromMom(childToParent.hasLifeChangingWordsFromMom);
    book.childToParent.changeLifeChangingWordsFromMom(childToParent.lifeChangingWordsFromMom);
    book.childToParent.changeCustomDate(childToParent.customDate);
    book.childToParent.changeChildName(childToParent.childName);
    book.childToParent.changeChildren(childToParent.children);
    book.childToParent.changeSibling(childToParent.sibling);
    book.childToParent.changeSiblingTemplate(childToParent.siblingTemplate);
    book.childToParent.changePets(childToParent.pets);
    book.childToParent.changePetsTemplate(childToParent.petsTemplate);
  }

  onSave = () => {
    // 顔の履歴を削除
    if (this.isChangeReceiver) {
      this.props.order.changeFacesSaved(false);
    }

    // ストーリーの履歴を削除
    if (this.isChangeChildren || this.isChangeSibling || this.isChangePets || this.isChangeReceiver) {
      this.props.book.childToParent.resetStories();
      this.props.order.changeStoriesSaved(false);
    }

    this.updateABook(this.props.book, this.state.book);
    this.props.order.nextStep();
  };

  componentWillMount() {
    if (this.props.book) {
      // 両親向け
      if (this.props.book.productType === 'child_to_parents') {
        receiverForParents = true;
      }
      // TODO: childTypeの指定 ここが適切か？
      const childType = this.props.book.artistName === 'aoyama' ? 'daughter' : 'son';
      this.props.book.childToParent.changeChildType(childType);
      this.updateABook(this.state.book, this.props.book);
    }
  }
  render() {
    const book = this.state.book;

    return (
      <div className="informations pd-15">
        <Form layout="vertical">
          <Row>
            <div style={{ padding: "0 0 8px" }}>
              {"あなたのお名前を教えてください。"}
              <br />
              <div style={{ fontSize: "11px", padding: "0 0 8px" }}>
                {"（敬称含め全角10文字以内）"}
              </div>
              <p style={{ fontSize: "10px", color: "#c00" }}>
                {"※姓名の間に必ず半角スペースを入力してください。"}
              </p>
              <p style={{ fontSize: "10px", color: "#c00", marginTop: "-1em" }}>
                {"※作者名として表紙等に印字されます。"}
              </p>
            </div>
            <div data-warning={isCNameTooLong}>
              <Input
                onChange={this.onCNameChange}
                placeholder={
                  this.props.book.artistName === "aoyama"
                    ? "例）山田 花子、やまだ はなこ"
                    : "例）山田 太郎、やまだ たろう"
                }
                span={24}
                size="large"
                style={{ fontSize: "14px" }}
                value={book.childToParent.creatorName}
              />
            </div>
          </Row>
          <Row style={{ display: receiverForParents ? 'none' : '' }}>
            <div className="label">
              {"プレゼントするお相手はどなたですか？"}
            </div>
            <FSelect
              defaultValue={`${book.childToParent.receiver}`}
              onChange={this.onReceiver}
              size="large"
            >
              {receiverList.map(item => (
                <Option key={item.value} value={item.value}>{item.text}</Option>
              ))}
            </FSelect>
          </Row>
          {((!receiverForParents && book.childToParent.receiver === "dad") || receiverForParents) && (
            <div>
              <Row
                data-warning={isDadNameTooLong}
                type="flex"
                justify="space-between"
              >
                <div>
                  {"お父さまのことを普段どのように呼んでいますか？"}
                  <br />
                  <div style={{ fontSize: "11px", padding: "0 0 8px" }}>
                    {"（敬称含め全角6文字以内）"}
                  </div>
                </div>
                <Input
                  span={24}
                  onChange={this.onDadNameChange}
                  placeholder="例）お父さん、パパ"
                  size="large"
                  style={{ fontSize: "14px" }}
                  value={book.childToParent.dadName}
                />
              </Row>
              <Row data-warning={isLifeChangingWordsFromDadTooLong}>
                <div>
                  {"あなたの人生を変えた”父”からの言葉があれば教えてください。"}
                  <br />
                  <div style={{ fontSize: "11px", padding: "0 0 8px" }}>
                    {"（全角20文字以内）"}
                  </div>
                  <p style={{ fontSize: "10px", color: "#c00" }}>
                    {"※特定のストーリーを選んだ場合にのみ使用されます。"}
                  </p>
                </div>
                <RadioGroup
                  defaultValue="0"
                  onChange={this.onHasLifeChangingWordsFromDadRadioChange}
                  value={book.childToParent.hasLifeChangingWordsFromDad}
                >
                  <Radio style={radioStyle} value="0" size="large">
                    特にない
                  </Radio>
                  <Radio style={radioStyle} value="1" size="large">
                    ある
                  </Radio>
                </RadioGroup>
                <div style={{ paddingTop: "8px" }}>
                  <Input
                    onChange={this.onLifeChangingWordsFromDadChange}
                    placeholder="例）本当に大切なのは結果よりプロセスだよ"
                    span={24}
                    size="large"
                    style={{ fontSize: "14px" }}
                    value={book.childToParent.lifeChangingWordsFromDad}
                    disabled={book.childToParent.hasLifeChangingWordsFromDad === "0"}
                  />
                </div>
              </Row>
            </div>
          )}
          {((!receiverForParents && book.childToParent.receiver === "mom") || receiverForParents) && (
            <div>
              <Row
                data-warning={isMomNameTooLong}
                type="flex"
                justify="space-between"
              >
                <div>
                  {"お母さまのことを普段どのように呼んでいますか？"}
                  <br />
                  <div style={{ fontSize: "11px", padding: "0 0 8px" }}>
                    {"（敬称含め全角6文字以内）"}
                  </div>
                </div>
                <Input
                  span={24}
                  onChange={this.onMomNameChange}
                  placeholder="例）お母さん、ママ"
                  size="large"
                  style={{ fontSize: "14px" }}
                  value={book.childToParent.momName}
                />
              </Row>
              <Row data-warning={isLifeChangingWordsFromMomTooLong}>
                <div>
                  {"あなたの人生を変えた”母”からの言葉があれば教えてください。"}
                  <br />
                  <div style={{ fontSize: "11px", padding: "0 0 8px" }}>
                    {"（全角20文字以内）"}
                  </div>
                  <p style={{ fontSize: "10px", color: "#c00" }}>
                    {"※特定のストーリーを選んだ場合にのみ使用されます。"}
                  </p>
                </div>
                <RadioGroup
                  defaultValue="0"
                  onChange={this.onHasLifeChangingWordsFromMomRadioChange}
                  value={book.childToParent.hasLifeChangingWordsFromMom}
                >
                  <Radio style={radioStyle} value="0" size="large">
                    特にない
                  </Radio>
                  <Radio style={radioStyle} value="1" size="large">
                    ある
                  </Radio>
                </RadioGroup>
                <div style={{ paddingTop: "8px" }}>
                  <Input
                    onChange={this.onLifeChangingWordsFromMomChange}
                    placeholder="例）本当に大切なのは結果よりプロセスだよ"
                    span={24}
                    size="large"
                    style={{ fontSize: "14px" }}
                    value={book.childToParent.lifeChangingWordsFromMom}
                    disabled={book.childToParent.hasLifeChangingWordsFromMom === "0"}
                  />
                </div>
              </Row>
            </div>
          )}
          <Row>
            <div>
              {(() => {
                const urlParams = new URLSearchParams(window.location.search);
                const hasKey = urlParams.has('key');
                return hasKey
                  ? "シカケテガミへの刻印日（挙式日など）をお選びください。"
                  : "シカケテガミに刻印する記念日をお選びください。";
              })()}
              <br />
              <div style={{ fontSize: "11px", padding: "0 0 8px" }}>
                {"（本の最終ページに印字されます）"}
              </div>
              <p style={{ fontSize: "11px", padding: "0 0 8px", color: "#c00" }}>
                {"※ 商品のお届け日をお約束するものではございません。"}
              </p>
            </div>
            <div
              className="c-calenderConfirm"
              data-over={isOverOneYear ? 'true' : 'false'}
            >
              <div className="c-calenderConfirm__comment"><span></span></div>
              <DatePicker
                allowClear={false}
                locale={locale}
                disabledDate={m => m.valueOf() <= moment().subtract(90, 'day').valueOf()}
                onChange={this.onDateChange}
                size="large"
                style={{ fontSize: "14px" }}
                value={moment(book.childToParent.customDate)}
              />
            </div>
          </Row>
          <br />
          <div className="label">（あなたの兄弟・姉妹についての情報）</div>
          <Row type="flex" justify="space-between">
            <Col span={11}>
              <div className="label">あなたの兄弟・姉妹の数</div>
              <FSelect
                defaultValue={`${book.childToParent.sibling}`}
                onChange={this.onSiblingChange}
                size="large"
              >
                <Option value="0">0人</Option>
                <Option value="1">1人</Option>
                <Option value="2">2人</Option>
              </FSelect>
            </Col>
          </Row>
          <SiblingTemplateRender book={book} />
          <br />
          <div className="label">（あなたのお子様についての情報）</div>
          <Row type="flex" justify="space-between">
            <Col span={11}>
              <div className="label">あなたのお子様の数</div>
              <FSelect
                defaultValue={`${book.childToParent.children}`}
                onChange={this.onChildrenChange}
                size="large"
              >
                <Option value="0">0人</Option>
                <Option value="1">1人</Option>
                <Option value="2">2人</Option>
                <Option value="3">3人</Option>
              </FSelect>
            </Col>
            {book.childToParent.children === 1 ? (
              <Col
                data-warning={isChildNameTooLong}
                span={11}
              >
                <div className="label">お子様の呼び名</div>
                <Input
                  onChange={this.onChildNameChange}
                  size="large"
                  style={{ fontSize: "14px" }}
                  value={book.childToParent.childName}
                />
              </Col>
            ) : null}
          </Row>
          <br />
          <div className="label">（ペットについての情報）</div>
          <Row type="flex" justify="space-between">
            <Col span={11}>
              <div className="label">犬・猫の有無</div>
              <FSelect
                defaultValue={`${book.childToParent.pets}`}
                onChange={this.onPetsChange}
                size="large"
              >
                <Option value="0">0匹</Option>
                <Option value="1">1匹</Option>
                <Option value="2">2匹</Option>
              </FSelect>
            </Col>
          </Row>
          <PetsTemplateRender book={book.childToParent} />
          <div className="btn-wrap" style={{ marginTop: "24px" }}>
            <button
              className="btn product-btn"
              disabled={!book.childToParent.isInfoSet ||
                isCNameTooLong ||
                isDadNameTooLong ||
                isLifeChangingWordsFromDadTooLong ||
                isMomNameTooLong ||
                isLifeChangingWordsFromMomTooLong ||
                isChildNameTooLong
              }
              onClick={this.onSave}
            >
              保存して次へ
              <img
                src="https://cdn.shopify.com/s/files/1/0012/2568/7076/files/arrow-right-purple.png?13701503969354364487"
                className="btn-arrow"
              />
            </button>
          </div>
        </Form>
      </div>
    );
  }
}

export default observer(Informations);



// WEBPACK FOOTER //
// ./src/components/steps/InformationsChildToParent.js